import { Autocomplete, Grid, TextField, Tooltip } from "@mui/material/index";
import { CBAttachmentFieldTypeNames, CBAttachmentFieldTypes, CBDossierKindKeys, IDocParam, IGetCargosPlace } from "../../types";
import { DatePicker } from "@mui/x-date-pickers";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Fragment } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
/**
 * Per far funzionare la formState.isDirtyFields per il DISABLED Del SAVE button in DOCUMENT MODAL
 * è NECESSARIO togliere i setValue(fields.{index}.valueS) e gestirli nella costruzione della request in create e update
 * leggendoli dai vari fields.value
 * Per il caso particolare di Citizenship e IssuingPlace dove i setValue() sono importanti è da verificare cosa sia
 * possibile fare. Lasciandoli vengono inseriti dei valori "null" nel formState.dirtyFields che non permettono di verificare che si è tornati al valore di default
 * 
 */
interface CutomerBaseAttachmentCustomFieldsProps {
    f: any, 
    index: number,
    cargosPlaceOptions: IGetCargosPlace[] | [],
    cargosPlaceCountryOptions: IGetCargosPlace[] | [],
    citizenshipCargosPlaceOptions: IGetCargosPlace[] | [],
    handleIssuingPlaceByDate: (param?: string | null) => void,
    handleIssuingPlaceCountryByDate: (param?: string | null) => void,
    onIssueDateChange: (value: string | null) => void

}
const CutomerBaseAttachmentCustomFields = ({
    f, 
    index,
    cargosPlaceOptions,
    cargosPlaceCountryOptions,
    citizenshipCargosPlaceOptions,
    handleIssuingPlaceByDate,
    handleIssuingPlaceCountryByDate,
    onIssueDateChange
} : CutomerBaseAttachmentCustomFieldsProps) => {

    const { t } = useTranslation("customerbase");
    const { control, setValue } = useFormContext<IDocParam>();

    const currentKind = useWatch<IDocParam, "kindIdentifier">({
        control: control, 
        name: "kindIdentifier"
    });

    const currentReleaseDate = useWatch<IDocParam, "issueDate">({
        control: control,
        name: "issueDate"
    });

    const currentExpireDate = useWatch<IDocParam, "expireDate">({
        control: control,
        name: "expireDate"
    });

    const issuingCountryValue = useWatch({
        control,
        name: "fields.999.value"
    });

    return (
        f.type?.type == CBAttachmentFieldTypes.ARRAY_OF_STRING ? 
            <Grid item md={3} xs={12}>
                        <Controller
                            control={control}
                            name={`fields.${index}.value`}
                            render={({field, fieldState}) => (
                                <Autocomplete 
                                    {...field}
                                    fullWidth
                                    id={`cb-dossier-${f.type?.name}-${index}`}
                                    options={f.type?.values || []}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params}
                                            label={t(`${f.type?.name}`)}
                                            required
                                            error={Boolean(fieldState.error)}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}
                                    value={field.value ? f.type?.values?.find((v : any) => v == field.value) || null : null}
                                    getOptionLabel={(option) => option}
                                    onChange={(_event, value) => {
                                        field.onChange(value);
                                        setValue(`fields.${index}.values`, !!value ? [value] : []);
                                    }}
                                />
                            )}
                        />
                    </Grid>
            :
            f.type?.type == CBAttachmentFieldTypes.STRING ?
            <Fragment>
            {(f.type?.name == CBAttachmentFieldTypeNames.CITIZENSHIP) ? 
                <Grid item md={3} xs={12} key={f.type?.name}>
                    <Controller
                        control={control}
                        name={`fields.${index}.value`}
                        render={({field, fieldState}) => (
                            <Tooltip title={citizenshipCargosPlaceOptions.length == 0 ? (t("tooltips.document.selectAField")) + ' ' + (currentKind == CBDossierKindKeys.LICENCE ?  t("firstReleaseDate") : t("issueDate")) : ''} arrow>
                                <Autocomplete 
                                    {...field}
                                    fullWidth
                                    id={`cb-dossier-${f.type?.name}-${index}`}
                                    options={citizenshipCargosPlaceOptions}
                                    disabled={citizenshipCargosPlaceOptions.length == 0}
                                    renderInput={(params) => (
                                        
                                            <TextField 
                                                {...params}
                                                label={t("citizenship")}
                                                required
                                                error={Boolean(fieldState.error)}
                                                helperText={fieldState.error?.message}
                                            />
                                    )}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option?.codice}>
                                                {option?.descrizione}
                                            </li>
                                        )
                                    }}
                                    value={field.value ? citizenshipCargosPlaceOptions.find((v) => v.codice == field.value) || null : null}
                                    getOptionLabel={(option) => option?.descrizione}
                                    onChange={(_event, value) => {
                                        field.onChange(value);
                                        const val = value?.codice || null;
                                        setValue(`fields.${index}.value`, val);
                                        setValue(`fields.${index}.values`, !!val ? [val] : []);
                                    }}
                                />
                            </Tooltip>
                        )}
                    />
                </Grid>
                :
                ((f.type?.name == CBAttachmentFieldTypeNames.ISSUE_DATE) ? 
                    <Grid item md={3} xs={12}>
                        <Controller
                            control={control}
                            name={`fields.${index}.value`}
                            render={({field, fieldState}) => (
                                <DatePicker
                                    value={field.value || null}
                                    onChange={(value) => {
                                        const val = dayjs(value).format("YYYY-MM-DD");
                                        field.onChange(val);
                                        setValue(`fields.${index}.values`, !!value ? [val] : []);

                                        if(dayjs(value).isValid()) {
                                            handleIssuingPlaceByDate(value);
                                            handleIssuingPlaceCountryByDate(value);
                                        }
                                        onIssueDateChange?.(value);

                                        //if(!value) setCargosPlaceOptions([]);
                                    }}
                                    //onClose={() => handleIssuingPlaceByDate(getValues(`fields.${index}.value`))}
                                    inputFormat={"DD/MM/YYYY"}
                                    //disabled={!currentReleaseDate}
                                    maxDate={!!currentReleaseDate ? currentReleaseDate : (!!currentExpireDate ? currentExpireDate : undefined)}
                                    renderInput={(params: any) => (
                                        <TextField 
                                            {...params}
                                            fullWidth
                                            id="issue-date-cf"
                                            label={currentKind == CBDossierKindKeys.LICENCE ?  t("firstReleaseDate") : t("releaseDate")}
                                            required
                                            error={Boolean(fieldState.error)}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}
                                />
                            )}
                        />
                    </Grid> 
                    :
                    ((f.type?.name == CBAttachmentFieldTypeNames.ISSUING_PLACE) ?
                        <Fragment>
                        <Grid item md={3} xs={12}>
                            <Controller
                                name={`fields.999.value`}
                                render={({field, fieldState}) => (
                                    <Tooltip title={cargosPlaceCountryOptions.length == 0 ? (t("tooltips.document.selectAField")) + ' ' + (currentKind == CBDossierKindKeys.LICENCE ?  t("firstReleaseDate") : t("releaseDate")) : ''} arrow>
                                        <Autocomplete
                                            {...field}
                                            fullWidth
                                            id={`cb-dossier-issuing-country-999`}
                                            options={cargosPlaceCountryOptions}
                                            disabled={cargosPlaceCountryOptions.length == 0}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t("issuingCountry")}
                                                    required
                                                    error={Boolean(fieldState.error)}
                                                    helperText={fieldState.error?.message}
                                                />
                                            )}
                                            renderOption={(props, option) => {
                                                return (
                                                    <li {...props} key={option?.codice}>
                                                        {option?.descrizione}
                                                    </li>
                                                )
                                            }}
                                            //isOptionEqualToValue={(option, value) => option.codice === value.codice}
                                            value={field.value ? cargosPlaceCountryOptions.find((v) => v.codice == field.value) || null : null}
                                            getOptionLabel={(option) => option?.descrizione}
                                            onChange={(_event, value) => {
                                                field.onChange(value);
                                                const val = value?.codice || null;
                                                if (val != "100000100") {
                                                    setValue(`fields.999.value`, val);
                                                    setValue(`fields.999.values`, !!val ? [val] : []);
                                                    setValue(`fields.${index}.value`, val);
                                                    setValue(`fields.${index}.values`, !!val ? [val] : []);
                                                } else {
                                                    setValue(`fields.999.value`, val);
                                                    setValue(`fields.999.values`, !!val ? [val] : []);
                                                    setValue(`fields.${index}.value`, null);
                                                    setValue(`fields.${index}.values`, []);
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            />
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Controller
                                control={control}
                                name={`fields.${index}.value`}
                                render={({field, fieldState}) => (
                                    <Tooltip title={cargosPlaceOptions.length == 0 ? (t("tooltips.document.selectAField")) + ' ' + (currentKind == CBDossierKindKeys.LICENCE ?  t("firstReleaseDate") : t("releaseDate")) : ''} arrow>
                                        <Autocomplete 
                                            {...field}
                                            fullWidth
                                            id={`cb-dossier-${f.type?.name}-${index}`}
                                            options={cargosPlaceOptions}
                                            disabled={issuingCountryValue != "100000100" || cargosPlaceOptions.length == 0}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params}
                                                    label={t("issuingPlace")}
                                                    required
                                                    error={Boolean(fieldState.error)}
                                                    helperText={fieldState.error?.message}
                                                />
                                            )}
                                            renderOption={(props, option) => {
                                                return (
                                                    <li {...props} key={option?.codice}>
                                                        {option?.descrizione} {'('}{option?.provincia}{')'}
                                                    </li>
                                                )
                                            }}
                                            //isOptionEqualToValue={(option, value) => option.codice === value.codice}
                                            value={field.value ? cargosPlaceOptions.find((v) => v.codice == field.value) || null : null}
                                            getOptionLabel={(option) => option?.descrizione}
                                            onChange={(_event, value) => {
                                                field.onChange(value);
                                                const val = value?.codice || null;
                                                setValue(`fields.${index}.value`, val);
                                                setValue(`fields.${index}.values`, !!val ? [val] : []);
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            />
                        </Grid>
                        </Fragment>
                        :
                        ((f.type?.name == CBAttachmentFieldTypeNames.ISSUING_AUTHORITY) ?
                            <Grid item md={3} xs={12}>
                                <Controller
                                    control={control}
                                    name={`fields.${index}.value`}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            id={`cb-dossier-${f.type?.name}-${index}`}
                                            label={t("issuingAuthority")}
                                            required
                                            value={field.value || ''}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                setValue(`fields.${index}.values`, !!value.target.value ? [value.target.value] : []);
                                            }}
                                            error={Boolean(fieldState.error)}
                                            helperText={fieldState.error?.message}
                                        />

                                    )}
                                />
                            </Grid>
                            
                            :
                            <Grid item md={3} xs={12}>
                                <Controller
                                    control={control}
                                    name={`fields.${index}.value`}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={t(`${f.type?.name}`)}
                                            required
                                            value={field.value || ''}
                                            error={Boolean(fieldState.error)}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}
                                />
                            </Grid>
                        )     
                    )
                )
            }
        </Fragment>
        :
        null
    )

}

export default CutomerBaseAttachmentCustomFields;